import React from 'react'
import { IconEwiInfo } from 'components/Zui/Icon'
import { InlineMessage } from 'components/Zui'

const MixedState = () => {
    return (
        <InlineMessage>
            The access rights for the individual files vary. To see who has access to an individual
            file and to manage the access rights select each files individually.
            <IconEwiInfo slot="icon" />
        </InlineMessage>
    )
}
export default MixedState
